import type { ReactNode } from 'react';

import { usePsapConfiguration } from './PsapConfigurationContext';

export type PsapFeatureViewProps = {
  children?: ReactNode;
  whenEnabled?: ReactNode;
  whenDisabled?: ReactNode;
  emergencyCallNotification?: boolean;
};

export function PsapFeatureView({
  children,
  whenEnabled,
  whenDisabled,
  emergencyCallNotification,
}: PsapFeatureViewProps) {
  const psapConfiguration = usePsapConfiguration();

  const isFeatureEnabled = (featureParameter: boolean | undefined, featureValue: boolean) =>
    featureParameter != null ? featureParameter === featureValue : true;

  const isVisible = isFeatureEnabled(
    emergencyCallNotification,
    psapConfiguration?.psapPortalConfiguration.psapPortalFeatures.allowEmergencyCallNotification ??
      false,
  );

  return isVisible ? <>{whenEnabled ?? children}</> : <>{whenDisabled}</>;
}
